import { AutoTocEntry, getAutoTocTitle } from '@livv/models';
import { getSheetLink } from '@livv/utils/helpers';
import { Box, Link as MuiLink, Typography } from '@mui/material';
import NextLink from 'next/link';
import { ReactNode } from 'react';
import { useBookPageContext } from '@utils/context/book';

const listSx = {
    listStyle: 'none',
    m: 0,
    p: 0,
};

const renderEntries = (entries: AutoTocEntry[], bookId: string, depth = 0): ReactNode =>
    entries.map((entry) => {
        if (entry.type === 'section') {
            return (
                <Box key={entry.path.join('/')} component="li" sx={{ mt: depth === 0 ? 3 : 2 }}>
                    <Typography sx={{ fontWeight: 600 }} variant={depth === 0 ? 'h4' : 'h5'}>
                        {entry.typography ? `${entry.typography} : ${entry.title}` : entry.title}
                    </Typography>
                    <Box component="ol" sx={{ ...listSx, pl: 3, pt: 1 }}>
                        {renderEntries(entry.items, bookId, depth + 1)}
                    </Box>
                </Box>
            );
        }

        return (
            <Box key={entry.id} component="li" sx={{ mt: 1 }}>
                <MuiLink
                    component={NextLink}
                    href={getSheetLink({
                        bookId,
                        bookPath: entry.path.join('/'),
                        sheetId: entry.id,
                    })}
                    underline="hover"
                >
                    {entry.label}
                </MuiLink>
            </Box>
        );
    });

const AutoTocPage = () => {
    const { autoToc = [], bookId, bookMeta } = useBookPageContext();

    return (
        <Box sx={{ maxWidth: (theme) => theme.spacing(80) }}>
            <Typography variant="h2" gutterBottom>
                {getAutoTocTitle(bookMeta.language)}
            </Typography>
            <Box component="ol" sx={{ ...listSx, pt: 2 }}>
                {renderEntries(autoToc, bookId)}
            </Box>
        </Box>
    );
};

export default AutoTocPage;
